import {Injectable} from '@angular/core';
import {URLSearchParams} from "@angular/http";
import {MyHttp} from "../../../app/core/http";
import {environment} from "../../../app/config/environment";

@Injectable()
export class OrganisationService {

  constructor(private http:MyHttp) {
  }

  searchOrganisations(query) {
    // Set filter params
    let params:URLSearchParams = new URLSearchParams();
    params.set('query', query);

    return this.http.get(`${environment.API}/organisations`,  { search: params })
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/interpreter-signup/organisation.service.ts